'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _paths = require('./paths');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_KEYS = Object.keys(_paths.PATHS);
/*
Example usage:
  <Icon icon="arrow-left" />
  <Icon icon="clipboard-check" color="red" />
  <Icon icon="map-marker" color="blue" size="30"/>

Props:
  icon: required
  color: optional (defaults to theme)
  size: optional (defaults to 16)
  onClick : optional
  className: optional
*/

var Icon = function Icon(props) {
  var styles = {
    svg: Object.assign({
      display: 'inline-block',
      verticalAlign: 'middle',
      height: props.size,
      width: props.size
    }, props.style || {}),
    path: {
      fill: props.color
    }
  };

  if (!props.icon) {
    console.warn('Icon property of Icon component cannot be undefined');
    return null;
  }

  var pathArr = _paths.PATHS[props.icon];
  if (!pathArr) {
    console.warn('Icon property value ' + props.icon + ' of Icon component not supported');
    return null;
  }

  var pathsMarkup = pathArr.map(function (path, index) {
    return _react2.default.createElement('path', { key: path + index, className: 'sd-icon-path', style: styles.path, d: path });
  });

  return _react2.default.createElement(
    'span',
    { className: 'anticon ' + props.className, onClick: props.onClick },
    _react2.default.createElement(
      'svg',
      {
        style: styles.svg,
        viewBox: '0 0 20 20' },
      pathsMarkup
    )
  );
};

Icon.defaultProps = {
  size: 20
};

Icon.propTypes = {
  icon: _propTypes2.default.oneOf(ICON_KEYS).isRequired
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sd-ui-components/dist/components/Icon/Icon.js
// module id = 454
// module chunks = 0